import * as api from '@/api/screening'
import Screening from '@/store/models/screening'
import formData from '@billow/js-helpers/src/utilities/form-data'

export let state = {
  screening: new Screening,
  screenings: {
    data: []
  },
  screeningList: []
}

export let mutations = {
  setScreenings: (state, payload) => state.screenings = payload,
  setScreeningList: (state, payload) => state.screeningList = payload,

  reset: state => state.screening = new Screening,
  setScreening: (state, payload) => state.screening = (new Screening).hydrate(payload),
  setTitle: (state, payload) => state.screening.title = payload,
  setDate: (state, payload) => state.screening.screening_date = payload,
  setStartTime: (state, payload) => state.screening.start_time = payload,
  setEndTime: (state, payload) => state.screening.end_time = payload,
  setFile: (state, payload) => state.screening.file = payload,
  setActive: (state, payload) => state.screening.active = payload
}

export let actions = {

  paginate: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginate(path, response => {
      commit('setScreenings', response.data)
      resolve()
    }, reject)
  }),

  load: ({ commit }, screening) => new Promise((resolve, reject) => {
    api.load(screening, response => {
      commit('setScreening', response.data)
      resolve()
    }, reject)
  }),

  create: ({ state, commit }) => new Promise((resolve, reject) => {
    api.create(formData(state.screening), () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  save: ({ state, commit }) => new Promise((resolve, reject) => {
    api.save(state.screening, () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  remove: ({ }, screening) => new Promise((resolve, reject) => {
    api.remove(screening.id, resolve, reject)
  })

}